// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"f3da5bbf","448":"7233694d","774":"cb1f21b6","787":"d6392bef"}[chunkId] + ".chunk.js";
};